import { render, staticRenderFns } from "./MyWhatsAppAccount.vue?vue&type=template&id=232fa7c2&scoped=true"
import script from "./MyWhatsAppAccount.vue?vue&type=script&lang=ts"
export * from "./MyWhatsAppAccount.vue?vue&type=script&lang=ts"
import style0 from "./MyWhatsAppAccount.vue?vue&type=style&index=0&id=232fa7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232fa7c2",
  null
  
)

export default component.exports